import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import img from "../../../asset/images/header.png";
import { MultiLanguageUrl } from "../../../constants/multiLanguage.constant";

type Props = {};

export default function SiteFindPlanComponent({}: Props) {
  const { t, i18n } = useTranslation();

  return (
    <section className="find-place position-relative">
      <Container fluid="xl" className="position-relative">
        <Row>
          <Col>
            <Row>
              <Col
                lg="7"
                md="9"
                sm="12"
                className="m-0 text-start  text-lg-start pt-xxl-5"
              >
                <Row className="pt-xxl-5">
                  <Col lg="8" className="pt-5 col-8">
                    <h1 className="color-sevenColor font-sofiaSans pt-4 pt-lg-0">
                      {t("home/SiteFindPlan/title")}
                    </h1>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <p className="color-sevenColor font-sofiaSans">
                      {t("home/SiteFindPlan/text-01")}
                    </p>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <Link
                      to={`${window.location.origin}/${
                        MultiLanguageUrl[i18n.language] || "en-US"
                      }/plans`}
                      className="btn btn-primary z-3 position-relative"
                      type="submit"
                    >
                      {t("home/SiteFindPlan/btn")}
                    </Link>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="position-absolute bottom-0 d-flex justify-content-center pe-2 pe-lg-0  flex-column header-img">
          <div className=" w-100 h-100 text-bg-danger position-relative">
            <div className="header-robot-img">
              <img
                crossOrigin="anonymous"
                src={
                  "https://cdn.1cdn.app/application/LOUISEBOT/23121307281973_23120406391356_louisebot.png"
                }
              />
            </div>
          </div>
          <div className="tw-z-50">
            <img
              crossOrigin="anonymous"
              src={
                "https://cdn.1cdn.app/application/LOUISEBOT/23100208270425_Knowledge_bases.png"
              }
              className="w-100 "
            />
          </div>
        </div>
      </Container>
      <svg
        viewBox="0 0 1440 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="footer-image-svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1440 0C1232.48 29.0766 985.313 45.9505 720 45.9505C454.687 45.9505 207.518 29.0766 0 4.75304e-05V46.8751H1440V0Z"
          fill="#F8F9FA"
        ></path>
      </svg>
    </section>
  );
}
